import { CompleteTaskViewController } from './complete-view.controller';
import { CompleteTaskViewProps } from './complete-view.model';

export const CompleteTaskView: React.FC<CompleteTaskViewProps> = (props) => {
  return <CompleteTaskViewController {...props} />;
};
